<template>
    <nuxt-link
        :to="linkUrl"
        :target="linkUrl.slice(0, 4) === 'http' ? '_blank' : ''"
        class="sales-block"
    >
        <div v-if="image" class="image">
            <img :src="image.url" :alt="image.alternativeText" />
        </div>
        <div v-if="title || description" class="mt-4">
            <h3 v-if="title" class="text-2xl font-semibold text-primary">
                {{ title }}
            </h3>
            <div v-if="description" class="mt-2">
                <rich-text :text="description" />
            </div>
        </div>
    </nuxt-link>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: '',
    },
    description: {
        type: String,
        default: '',
    },
    image: {
        type: Object,
        default: null,
    },
    linkUrl: {
        type: String,
        default: '',
    },
});
</script>

<style lang="scss" scoped>
.sales-block {
    display: block;
    background-color: $lighter-gray;
    padding: 1rem;
    border: 0.05rem solid $lighter-gray;
    .image {
        @apply w-full;
        aspect-ratio: 1/1;
        img {
            @apply w-full h-full object-cover;
        }
    }
}
</style>
